import React, { useState } from "react";
import { handleWalletDeposit } from "services/walletService";
import { TransactionSummary } from "../reusables";
import styles from '../wallet.module.css';
const DepositSummary = ({onNext, onPrevious, values,...props}) => {
    const data ={
        "Amount": values.amount || "₦1",
        "Recipient": `${values.accountName} (${values.bankName})`,
        "Remark": values.memo,
        "Date" : values.date || "12/04/22 15:37"

    }
    const [isLoading, setIsLoading] = useState(false)
    const onCompleteHandler = async(e) => {
        try{
            setIsLoading(true)
            const {data, message, status} = await handleWalletDeposit("ngn", parseFloat(values.amount.replace(/[₦\,]+/g, '') || "0.0"));
            if(status == "Ok"){
                
                onNext(e, null, data);
            }

        }
        catch(err){
            onNext?.(e,err, null)
        }
        finally{
            setIsLoading(false)
        }
        
    } 
    return (
        <div className={styles.Deposit}>
            <TransactionSummary isLoading={isLoading} onComplete={onCompleteHandler} onPrevious={onPrevious} 
            data={data} />
        </div>
    )
}

export default DepositSummary;